import React, { useState, useEffect } from "react";
import { register } from "../../function/auth";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom"; // นำเข้า useNavigate
import logo from "./logo/logo.png";

const Register = () => {
  const navigate = useNavigate(); // เรียกใช้ useNavigate
  const [value, setValue] = useState({
    username: "",
    email: "",
    password: "",
    password1: "",
  });

   useEffect(() => {
    // เช็ค token ใน localStorage (หรือจะเช็ค Redux ก็ได้)
    if (localStorage.getItem("token")) {
      navigate("/", { replace: true }); // redirect ไปหน้า login
    }
  }, [navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (value !== undefined) {
      setValue((prev) => ({ ...prev, [name]: value.replace(/\s/g, "") }));
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === " ") {
      e.preventDefault();
      toast.warning("ไม่สามารถใช้ช่องว่างในรหัสผ่านได้");
    }
  };

  const isValidUsername = (text) => /^[a-zA-Z0-9_.]+$/.test(text);
  const handleSubmit = (e) => {
  e.preventDefault();
  if (!isValidUsername(value.username)) {
    toast.error("Username ใช้ได้เฉพาะ a-z, A-Z, 0-9 และ _ เท่านั้น");
    return;
  }
  if (value.password !== value.password1) {
    alert("Password Not Match");
  } else {
    register(value)
      .then((res) => {
        toast.success("สมัครสมาชิกสำเร็จ!");
        navigate("/login");
      })
      .catch((err) => {
        console.log(err.response.data);
        toast.error(err.response.data);
      });
  }
};

  return (
    <div className="container p-5">
      <div className="row justify-content-center">
        <div
          className="col-md-6"
          style={{
            boxShadow: "0 3px 10px rgba(150, 27, 78, 0.7)",
            padding: "15px",
            borderRadius: "5px",
          }}
        >
          <div className="text-center mb-4">
            <img
              src={logo}
              alt="Logo"
              className="img-fluid"
              style={{ maxWidth: "200px" }}
            />
            <h4>สมัครสมาชิก</h4>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Username</label>
              <input
                className="form-control"
                type="text"
                name="username"
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>Email</label>
              <input
                className="form-control"
                type="email"
                name="email"
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>Password</label>
              <input
                className="form-control"
                type="password"
                name="password"
                autoComplete="new-password" 
                onChange={handleChange}
                onKeyDown={handleKeyDown}
              />
            </div>

            <div className="form-group">
              <label>Confirm Password</label>
              <input
                className="form-control"
                type="password"
                name="password1"
                onChange={handleChange}
                onKeyDown={handleKeyDown}
              />
            </div>

            <br />
            <div className="d-flex justify-content-center">
              <button
                className="btn"
                style={{ backgroundColor: "#4CB4F6", color: "#fff" }}
                disabled={value.password.length < 6}
              >
                ยืนยัน
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Register;
